export const chartContainerSx = (theme) => ({
  backgroundColor: theme.palette.background.secondary,
  borderRadius: '5px',
  margin: '8px 0px 24px 0px',
  maxHeight: '300px',
  maxWidth: '345px',
});

export const chartSx = (theme) => ({
  '.MuiChartsAxis-line': {
    stroke: '#71767b',
  },
  '.MuiChartsAxis-label': {
    fill: theme.palette.secondary.main,
  },
  '.MuiChartsAxis-tickLabel': {
    fill: '#71767b',
  },
});
